export default __webpack_public_path__ + "src/assets/images/unsplash_modal.png";